<ngx-spinner bdColor = "rgba(0, 0, 0, 0.3)" size = "medium" color = "#141414" type = "ball-scale" [fullScreen] = "true"></ngx-spinner>
